import userService from "../../../services/user.service";

  async function getAllRoles() {
    try {
      const payload = {
        pageNumber: -1,
        pageSize: 0,
        searchQuery: "",
      };
  
      const response = await userService.getRoles(
        payload.pageNumber,
        payload.pageSize,
        payload.searchQuery
      );
  
      if (response.data && response.data.status) {
        const reduced = response.data.result.map((role) => ({
          id: role.id,
          name: role.name,
          description: role.description,
          active: role.active,
        }));
        return JSON.stringify(reduced);
      } else {
        return (
          JSON.stringify(response.data.message) || "Failed to fetch roles."
        );
      }
    } catch (error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        "An unexpected error occurred.";
      console.error("Error fetching roles:", errorMessage);
      return JSON.stringify(errorMessage);
    }
  }
  async function addRole({ name, description, active, roleGroup }) {
    try {
      const payload = {
        name,
        description,
        active,
        roleGroup, 
      };
  
      const response = await userService.addRole(payload);
      if (response.data && response.data.status) {
        console.log("Role added:", response.data.result);
        return JSON.stringify(response.data.result);
      } else {
        return (
          JSON.stringify(response.data.message) ||
          "Failed to add role."
        );
      }
    } catch (error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        "An unexpected error occurred.";
      console.error("Error adding role:", errorMessage);
      return JSON.stringify(errorMessage);
    }
  }
  async function updateRole({ id, name, description, active, roleGroup }) {
    try {
      const payload = {
        id,
        name,
        description,
        active,
        roleGroup, 
      };
  
      const response = await userService.updateRole(payload);
      if (response.data && response.data.status) {
        console.log("Role updated:", response.data.result);
        return JSON.stringify(response.data.result);
      } else {
        return (
          JSON.stringify(response.data.message) ||
          "Failed to update role."
        );
      }
    } catch (error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        "An unexpected error occurred.";
      console.error("Error updating role:", errorMessage);
      return JSON.stringify(errorMessage);
    }
  }
  
  export default {
    getAllRoles,
    addRole,
    updateRole,
    roleTools: [
      {
        type: "function",
        function: {
          name: "getAllRoles",
          description:
            "Get roles from the database. Roles define user access within the application.",
          parameters: {
            type: "object",
            properties: {
                pageNumber: {
                    type: "number",
                    description:
                      "The page number for paginated results. Dont ask this just use default values. by default it is -1 for fetching all roles",
                  },
                  pageSize: {
                    type: "number",
                    description:
                      "The number of items per page. by default it is 0 for fetching all roles",
                  },
                  searchQuery: {
                    type: "string",
                    description:
                      "Search query to filter cities. by default it is empty string for fetching all roles",
                  },
            }
          },
        },
      },
      {
        type: "function",
        function: {
          name: "addRole",
          description: `Add a new role to the system. 
            Before calling this function, you MUST call getAllPermissionsGroup to get available permission groups. 
            Then present all the groups (must not skip any) in a multiselect field. Also, present fields for role name, description, and active status.`,
          parameters: {
            type: "object",
            properties: {
              name: {
                type: "string",
                description: "The name of the role.",
              },
              description: {
                type: "string",
                description: "A brief description of what this role is about.",
              },
              active: {
                type: "boolean",
                description: "Whether the role is active.",
              },
              roleGroup: {
                type: "array",
                items: {
                  type: "integer",
                },
                description:
                  "Multiselect field. An array of permission group IDs associated with this role. Use getAllPermissionsGroup to retrieve and display all groups for selection.",
              },
            },
            required: ["name", "description", "active", "roleGroup"],
          },
        },
      },
      {
        type: "function",
        function: {
          name: "updateRole",
          description: `Update an existing role in the system. 
            Before calling this function, you MUST call getAllPermissionsGroup to get the available permission groups 
            and getRoles to show existing roles. Let the user select a role, modify its fields and associated groups.`,
          parameters: {
            type: "object",
            properties: {
              id: {
                type: "integer",
                description: "The ID of the role to update.",
              },
              name: {
                type: "string",
                description: "The updated name of the role.",
              },
              description: {
                type: "string",
                description: "The updated description of the role.",
              },
              active: {
                type: "boolean",
                description: "Whether the role is active.",
              },
              roleGroup: {
                type: "array",
                items: {
                  type: "integer",
                },
                description:
                  "Multiselect field. An array of permission group IDs to associate with this role. Use getAllPermissionsGroup to fetch available groups.",
              },
            },
            required: ["id", "name", "description", "active", "roleGroup"],
          },
        },
      }
      
      
     
    ],
  };